<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/internal-control')" style="cursor: pointer">Control Interno</li>
        <li class="breadcrumb-item active" aria-current="page">Creador de expedientes</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <vx-card>
        <h3>Creador de expedientes</h3>
        <!-- PARAMETROS DE BUSQUEDA -->
        <div class="vx-row">
            <div class="vx-col w-full lg:w-1/3">
                <vs-select
                color="dark"
                placeholder="Seleccione"
                label="Opción de búsqueda"
                class="w-full"
                v-model.lazy="searchOptionSelected"
                >
                    <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in searchOptions" />
                </vs-select>
            </div>
            <div class="vx-col w-full lg:w-1/3">
                <vs-input
                    color="dark"
                    class="w-full"
                    label="Ingrese"
                    v-model="inputSearch"
                    v-on:keyup.enter="searchUserData(searchOptionSelected, inputSearch)"
                />                    
            </div>
            <div class="vx-col w-full lg:w-1/3">
                <vs-button :disabled="!inputSearch || !searchOptionSelected" @click="searchUserData(searchOptionSelected, inputSearch)" color="dark" class="mt-6 btn-rgprimary">Consultar</vs-button>
            </div>
        </div>
      </vx-card>
      
      <template v-if="resultDataResponse">
        <!-- RESPUESTA DE BUSQUEDA -->
        <div class="vx-row mb-base">
          <div class="vx-col w-full xl:w-1/3 mt-5">
            <!-- DATOS DEL USUARIO SI ES PERSONA FISICA -->
            <template v-if="personalProfileData">
              <vx-card> 
                  <div class="mb-5 text-center">
                    <!-- <vs-avatar color="white" size="80px" :src="avatarUrlIcon" class="img-responsive" /><br> -->
                    <!-- <h5 class="bold">{{ userName }}</h5> -->
                    <label>
                      <b>Domicilio: </b>{{ this.personalProfileData.full_address }}
                    </label>
                  </div>
                  <vs-list>
                    <vs-list-item title="Nombre(s)">{{ this.personalProfileData.names }}</vs-list-item>
                    <vs-list-item title="Apellido paterno">{{ this.personalProfileData.last_name_1 }}</vs-list-item>
                    <vs-list-item title="Apellido materno">{{ this.personalProfileData.last_name_2 }}</vs-list-item>
                    <vs-list-item title="Género">{{ this.personalProfileData.gender }}</vs-list-item>
                    <vs-list-item title="Fecha de nacimiento">{{ this.personalProfileData.birth_date }}</vs-list-item>
                    <vs-list-item title="País de nacimiento">{{ this.personalProfileData.origin_country }}</vs-list-item>
                    <vs-list-item title="Nacionalidad">{{ this.personalProfileData.citizenship }}</vs-list-item>
                    <vs-list-item title="País de residencia">{{ this.personalProfileData.country }}</vs-list-item>
                    <!-- <template v-if="this.resultDataResponse.person_type == 1"> -->
                      <vs-list-item title="Entidad Federativa de nacimiento">{{ this.personalProfileData.birth_state || '--' }}</vs-list-item>
                      <vs-list-item title="CURP">{{ this.personalProfileData.curp || '--' }}</vs-list-item>
                      <vs-list-item title="Clave de elector">{{ this.personalProfileData.official_id_code || '--' }}</vs-list-item>
                    <!-- </template> -->
                    <vs-list-item title="Teléfono">{{ this.personalProfileData.phone }}</vs-list-item>
                    <vs-list-item title="Verificación SMS">{{ this.personalProfileData.sms_verification_date }}</vs-list-item>
                    <vs-list-item title="WhatsApp Habilitado">{{ this.personalProfileData.whatsapp_enabled }}</vs-list-item>
                    <vs-list-item title="Correo electrónico">{{ this.resultDataResponse.email }}</vs-list-item>
                    <vs-list-item title="Verificación Correo">{{ this.resultDataResponse.email_response }}</vs-list-item>
                    <vs-list-item title="Ocupación">{{ this.personalProfileData.occupation }}</vs-list-item>
                    <vs-list-item title="Sector">{{ this.personalProfileData.sector }}</vs-list-item>
                    <template v-if="this.resultDataResponse.geolocation">
                      <vs-list-item title="Geolocalización" :subtitle="this.resultDataResponse.geolocation_str">
                        <vs-button target color="success" radius icon-pack="feather" icon="icon-map-pin" :href="$sanitizeUrl(this.resultDataResponse.geolocation)"></vs-button>
                      </vs-list-item>
                    </template>
                    <vs-list-item v-else title="Geolocalización">
                      <label>No disponible</label>
                    </vs-list-item>
                    <vs-list-item v-if="this.personalProfileData.identity_verification_status" title="Verificación de identidad" :subtitle="this.personalProfileData.identity_verification_status">
                      <vs-button :disabled="!this.personalProfileData.identity_verification_url" target color="dark" radius icon-pack="feather" icon="icon-user" :href="$sanitizeUrl(this.personalProfileData.identity_verification_url)"></vs-button>
                    </vs-list-item>
                    <vs-list-item v-else title="Verificación de identidad">
                      <label>No realizada</label>
                    </vs-list-item>
                  </vs-list>
                  <div class="flex justify-between flex-wrap small-flex mt-5">
                    <vs-button @click="popUpUploadDocumentActive = true" color="success">Subir documento</vs-button>
                    <vs-button :disabled="resultDataResponse.count_documents <= 0" @click="downloadUserDocuments" color="dark">Descargar documentos ({{ resultDataResponse.count_documents }})</vs-button>
                  </div>
              </vx-card>
            </template>
            <!-- DATOS DEL USUARIO SI ES PERSONA MORAL -->
            <template v-if="businessProfileData">
              <vx-card> 
                  <div class="mb-5 text-center">
                    <!-- <vs-avatar color="white" size="80px" :src="avatarUrlIcon" class="img-responsive" /><br> -->
                    <h5><b>Denominación o razón social:</b> {{ userName }}</h5>
                    <label>
                      <b>Domicilio:</b> {{ this.businessProfileData.full_address }}
                    </label>
                  </div>
                  <vs-list>
                      <vs-list-item title="Giro mercantil, actividad u objeto social">{{ this.businessProfileData.business_activity }}</vs-list-item>
                      <vs-list-item title="Nacionalidad">{{ this.businessProfileData.nationality }}</vs-list-item>
                      <vs-list-item title="País de residencia">{{ this.businessProfileData.country }}</vs-list-item>
                      <vs-list-item title="Teléfono">{{ this.businessProfileData.phone }}</vs-list-item>
                      <vs-list-item title="Verificación SMS">{{ this.businessProfileData.sms_verification_date }}</vs-list-item>
                      <vs-list-item title="WhatsApp Habilitado">{{ this.businessProfileData.whatsapp_enabled }}</vs-list-item>
                      <vs-list-item title="Correo electrónico">{{ this.resultDataResponse.email }}</vs-list-item>
                      <vs-list-item title="Verificación Correo">{{ this.resultDataResponse.email_response }}</vs-list-item>
                      <vs-list-item title="Fecha de constitución">{{ this.businessProfileData.constitution_date }}</vs-list-item>
                  </vs-list>
                  <vs-list v-if="this.businessProfileData.legal_representative_data">
                    <vs-list-header icon-pack="feather" icon="icon-user" title="REPRESENTANTE LEGAL"></vs-list-header>
                    <vs-list-item title="Nombre">{{ this.businessProfileData.legal_representative_data.legal_representative_name }}</vs-list-item>
                    <vs-list-item v-if="this.businessProfileData.legal_representative_data.identity_verification_status" title="Verificación de identidad" :subtitle="this.businessProfileData.legal_representative_data.identity_verification_status">
                      <vs-button :disabled="!this.businessProfileData.legal_representative_data.identity_verification_url" target color="dark" radius icon-pack="feather" icon="icon-user" :href="$sanitizeUrl(this.businessProfileData.legal_representative_data.identity_verification_url)"></vs-button>
                    </vs-list-item>
                    <vs-list-item v-else title="Verificación de identidad">
                      <label>No realizada</label>
                    </vs-list-item>
                  </vs-list>
                  <vs-list v-if="this.businessProfileData.stakeholders.length > 0">
                    <vs-list-header icon-pack="feather" icon="icon-users" title="ESTRUCTURA ACCIONARIA"></vs-list-header>
                    <div v-for="(stakeholder, i) in this.businessProfileData.stakeholders" :key="s">
                      <vs-list-item :title="stakeholder.name">{{ prcgFormat(stakeholder.share, 2) }}</vs-list-item>
                    </div>
                  </vs-list>
                  <div class="flex justify-between flex-wrap small-flex mt-5">
                    <vs-button @click="popUpUploadDocumentActive = true" color="success">Subir documento</vs-button>
                    <vs-button :disabled="resultDataResponse.count_documents <= 0" @click="downloadUserDocuments" color="dark">Descargar documentos ({{ resultDataResponse.count_documents }})</vs-button>
                  </div>
              </vx-card>
            </template>
            <!-- ROLES DE USUARIO -->
            <vx-card class="mt-5" v-if="resultDataResponse.roles_data">
              <h5 class="bold">Cuenta</h5>
              <div v-for="(role, i) in resultDataResponse.roles_data" :key="i">
                <vs-list>
                    <vs-list-header icon-pack="feather" icon="icon-user" :title="role.role_name"></vs-list-header>
                    <vs-list-item title="Id">{{role.role_id}}</vs-list-item>
                    <vs-list-item v-if="role.contract_level" title="Nivel de contrato">{{role.contract_level}}</vs-list-item>
                    <vs-list-item v-if="role.onboarding_step" title="Flujo de onboarding">{{role.onboarding_step}}</vs-list-item>
                    <vs-list-item v-if="role.cancellation_account_date" title="Cancelación de cuenta">{{role.cancellation_account_date}}</vs-list-item>
                    <vs-list-item title="CLABE STP">{{role.stp_clabe}}</vs-list-item>
                    <vs-list-item title="Estatus STP">{{role.stp_status}} <span :class="stpAccountColor(role.stp_status)"></span></vs-list-item>
                    <vs-list-item v-if="role.stp_error_details" title="Detalles">{{role.stp_error_details}}</vs-list-item>
                    <vs-list-item v-if="role.role_name_db == 'investor' || role.role_name_db == 'client'" title="Estados de cuenta">
                      <vs-button @click="selectPeriodStatements(role)" size="small" color="dark">Descargar</vs-button>
                    </vs-list-item>
                </vs-list>
              </div>
            </vx-card>
            <!-- BENEFICIARIOS DE USUARIO POR ROL -->
            <vx-card class="mt-5" v-if="resultDataResponse.beneficiaries_data.length > 0">
              <h5 class="bold">Beneficiarios</h5>
              <div v-for="(role, i) in resultDataResponse.beneficiaries_data" :key="i">
                <vs-list>
                    <vs-list-header icon-pack="feather" icon="icon-user" :title="role.role_name"></vs-list-header>
                    <vs-list-item v-for="(beneficiary, i) in role.beneficiaries" :key="i" :title="beneficiary.complete_name">{{ decimalPercentFormat(beneficiary.beneficiary_percentage, 0)}}</vs-list-item>
                </vs-list>              
              </div>
            </vx-card>
          </div>

          <!-- CARDS -->
          <div class="vx-col w-full xl:w-2/3 mt-5">
            <!-- PERFIL TRANSACCIONAL DE USUARIO -->
            <vx-card v-if="resultDataResponse.kyc_data">
              <h5 class="bold">Perfíl Transaccional</h5>
              <div v-for="(kyc, i) in resultDataResponse.kyc_data" :key="i">
                  <vs-list>
                      <vs-list-header icon-pack="feather" icon="icon-briefcase" :title="kyc.role_name"></vs-list-header>
                      <vs-list-item title="Origen de recursos">{{getOption(kyc.sof_type, collections.sofTypes)}}</vs-list-item>
                      <vs-list-item title="Número de transacciones mensuales">{{getOption(kyc.number_monthly_transactions, collections.numberMonthlyTransactions)}}</vs-list-item>
                      <vs-list-item title="Depósitos promedio mensual">{{getOption(kyc.initial_trx_profile_average_deposit, collections.initialTrxProfileAverageDeposits)}}</vs-list-item>
                      <vs-list-item title="Monto aproximado de ingresos mensuales">
                        <template v-if="personalProfileData">
                          {{getOption(kyc.average_monthly_earnings_mxn, collections.averageMonthlyEarningsMxnPf)}}
                        </template>
                        <template v-else>
                          {{getOption(kyc.average_monthly_earnings_mxn, collections.averageMonthlyEarningsMxnPm)}}
                        </template>
                      </vs-list-item>
                      <vs-list-item title="Destino de los recursos">{{getOption(kyc.dof_type, collections.dofTypes)}}</vs-list-item>
                      <vs-list-item title="Propósito de negocio">{{kyc.business_purpose}}</vs-list-item>
                      <vs-list-item v-if="kyc.last_profile_update_confirmation_timestamp" title="Fecha actualización expediente">{{regularDateFormat(kyc.last_profile_update_confirmation_timestamp)}}</vs-list-item>
                  </vs-list>
              </div>
            </vx-card>

  
            <!-- CONTRATOS DE USUARIO -->
            <vx-card class="mt-5" v-if="resultDataResponse.contracts_data">
              <h5 class="bold">Contratos</h5>
              <div v-for="(contract, i) in resultDataResponse.contracts_data" :key="i">
                  <vs-list>
                      <vs-list-header icon-pack="feather" icon="icon-book-open" :title="contract.document.toUpperCase()"></vs-list-header>
                      <vs-list-item title="Versión del documento">{{contract.version}}</vs-list-item>
                      <vs-list-item title="Fecha de aceptación">{{signatureFormatDate(contract.acceptance_date)}}</vs-list-item>
                      <vs-list-item title="Agente">{{contract.agent}}</vs-list-item>
                      <vs-list-item title="IP">{{contract.ip}}</vs-list-item>
                      <vs-list-item title="Correo electrónico">{{contract.email}}</vs-list-item>
                      <vs-list-item v-if="contract.geolocation != null && contract.geolocation != '--'" title="Ubicación">{{contract.geolocation}}</vs-list-item>
                      <vs-list-item title="Archivo">
                        <vs-button @click="downloadContract(contract)" size="small" color="dark">Descargar</vs-button>
                      </vs-list-item>
                  </vs-list>
              </div>
            </vx-card>
  
            <!-- PERFIL FISCAL DE USUARIO -->
            <vx-card class="mt-5" v-if="this.resultDataResponse.person_type == 1 || this.resultDataResponse.person_type == 0">
              <h5 class="bold">Perfíl Fiscal</h5>
              <vs-list>
                <vs-list-item title="RFC">{{ this.resultDataResponse.tax_profile.rfc }}</vs-list-item>
                <vs-list-item title="Nombre fiscal">{{ this.resultDataResponse.tax_profile.taxName }}</vs-list-item>
                <vs-list-item title="Régimen fiscal">{{ this.resultDataResponse.tax_profile.taxRegime }}</vs-list-item>
                <vs-list-item title="Código postal fiscal">{{ this.resultDataResponse.tax_profile.taxZipcode }}</vs-list-item>
                <vs-list-item title="Uso de CFDI">{{ this.resultDataResponse.tax_profile.cfdi }}</vs-list-item>
                <vs-list-item title="Número de serie de efirma" v-if="this.resultDataResponse.person_type == 0">{{ this.resultDataResponse.tax_profile.efirmaNumber }}</vs-list-item>
                <vs-list-item title="Validación">{{ explicitDateFormat(this.resultDataResponse.tax_profile.fiscalValidationTimestamp) }}</vs-list-item>
              </vs-list>
            </vx-card>
  
            <!-- SEGURIDAD DE USUARIO -->
            <!-- <vx-card class="mt-5" v-if="this.resultDataResponse.person_type == 1 || this.resultDataResponse.person_type == 0"> -->
            <vx-card class="mt-5">
              <h5 class="bold">Seguridad</h5>
              <vs-list>
                  <vs-list-item title="ID de Usuario">{{this.resultDataResponse.user_id}}</vs-list-item>
                  <vs-list-item title="Fecha de creación de usuario">{{this.resultDataResponse.user_created_at}}</vs-list-item>
                  <vs-list-item title="Estado">{{this.resultDataResponse.active_status}}</vs-list-item>
                  <vs-list-item title="Fecha de último acceso">{{this.resultDataResponse.user_last_login}}</vs-list-item>
                  <vs-list-item title="Segundo Factor de Autenticación">{{this.resultDataResponse.user_2fa}}</vs-list-item>
              </vs-list>
            </vx-card>

            <!-- PLD DE USUARIO -->
            <vx-card v-if="showUserPldCard" class="mt-5">
              <div class="flex justify-between flex-wrap small-flex">
                <h5 class="bold">Listas PLD del usuario</h5>
                <vs-button size="small" @click="sendQuestionnaire()" color="success">Enviar cuestionario riesgo bajo-medio</vs-button>
              </div>
              <div class="vx-row">
                <div v-for="(dataRestriction, indextr) in collections.userRestrictions" class="vx-col w-full lg:w-1/3">
                  <div class="flex mt-5">
                    <vs-switch class="mt-4" color="success" @change="switchPldOption(dataRestriction)" v-model="userRestrictions" :vs-value="dataRestriction.id"/>
                    <vs-collapse accordion class="w-full">
                      <vs-collapse-item>
                        <div slot="header">
                          <strong>{{ dataRestriction.name }}</strong>
                        </div>
                        <vs-list-item title="Alta:"></vs-list-item>
                        <vs-list-item v-for="(instruction, indextr) in dataRestriction.up_instructions" :subtitle="instruction"></vs-list-item>
                        <vs-list-item v-if="dataRestriction.name == 'LPB'" subtitle="No. Oficio">
                          <vs-input 
                            size="small"
                            type="text" 
                            v-model.lazy="officialLetterNumber"
                            name="officialLetterNumber" />
                        </vs-list-item>
                        <template v-if="dataRestriction.down_instructions">
                          <vs-list-item title="Baja:"></vs-list-item>
                          <vs-list-item v-for="(instruction, indextr) in dataRestriction.down_instructions" :subtitle="instruction"></vs-list-item>
                        </template>
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>
                </div>
              </div>
            </vx-card>
  
            <!-- PROYECTOS DE USUARIO EN CASO DE BUSCAR POR CID -->
            <vx-card class="mt-5" v-if="searchOptionSelected === 'CID'">
              <h5 class="bold">Proyectos</h5>
              <vs-table
                ref="projectsTable"
                stripe
                :data="resultDataResponse.projects_data"
                noDataText="No hay datos disponibles"
              >
                <template slot="thead">
                  <vs-th>PID</vs-th>
                  <vs-th>Alias</vs-th>
                  <vs-th>Documentación</vs-th>
                  <vs-th>Edos. de cuenta</vs-th>
                </template>
  
                <template slot-scope="{ data }">
                  <vs-tr
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                    :data="tr"
                  >
                    <vs-td class="bold"><a :href="$sanitizeUrl('/cobranza/' + tr.id)" target="blank">{{tr.id}}</a></vs-td>
                    <vs-td>{{ tr.alias }}</vs-td>
                    <vs-td>
                      <vs-button @click="downloadProjectDocuments(tr.id)" :disabled="tr.count_documents <= 0" size="small" color="primary">Descargar ({{ tr.count_documents }})</vs-button>
                    </vs-td>
                    <vs-td>
                      <vs-button @click="selectProjectStatements(tr.id)" size="small" color="primary">Descargar</vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
            
            <!-- TABS -->
            <!-- <vx-card>
                <vs-tabs color="dark" alignment="center">
                  <vs-tab v-if="resultDataResponse.roles_data" label="Cuenta">
                    <div>
                        <div v-for="(role, i) in resultDataResponse.roles_data" :key="i">
                            <vs-list>
                                <vs-list-header icon-pack="feather" icon="icon-user" :title="role.role_name"></vs-list-header>
                                <vs-list-item title="Id">{{role.role_id}}</vs-list-item>
                                <vs-list-item title="CLABE STP">{{role.stp_clabe}}</vs-list-item>
                                <vs-list-item title="Estatus STP">{{role.stp_status}}</vs-list-item>
                            </vs-list>
                        </div>
                    </div>
                  </vs-tab>
                  <vs-tab v-if="resultDataResponse.contracts_data" label="Contratos">
                    <div>
                        <div v-for="(contract, i) in resultDataResponse.contracts_data" :key="i">
                            <vs-list>
                                <vs-list-header icon-pack="feather" icon="icon-book-open" :title="contract.document.toUpperCase()"></vs-list-header>
                                <vs-list-item title="Versión del documento">{{contract.version}}</vs-list-item>
                                <vs-list-item title="Fecha de aceptación">{{signatureFormatDate(contract.acceptance_date)}}</vs-list-item>
                                <vs-list-item title="Agente">{{contract.agent}}</vs-list-item>
                                <vs-list-item title="IP">{{contract.ip}}</vs-list-item>
                                <vs-list-item title="Correo electrónico">{{contract.email}}</vs-list-item>
                                <vs-list-item v-if="contract.geolocation != null && contract.geolocation != '--'" title="Ubicación">{{contract.geolocation}}</vs-list-item>
                            </vs-list>
                        </div>
                    </div>
                  </vs-tab>
                  <vs-tab v-if="resultDataResponse.kyc_data" label="Perfil Transaccional">
                    <div>
                        <div v-for="(kyc, i) in resultDataResponse.kyc_data" :key="i">
                            <vs-list>
                                <vs-list-header icon-pack="feather" icon="icon-briefcase" :title="kyc.role_name"></vs-list-header>
                                <vs-list-item title="Origen de recursos">{{getOption(kyc.sof_type, collections.sofTypes)}}</vs-list-item>
                                <vs-list-item title="Número de transacciones mensuales">{{getOption(kyc.number_monthly_transactions, collections.numberMonthlyTransactions)}}</vs-list-item>
                                <vs-list-item title="Depósitos promedio mensual">{{getOption(kyc.initial_trx_profile_average_deposit, collections.initialTrxProfileAverageDeposits)}}</vs-list-item>
                                <vs-list-item title="Destino de los recursos">{{getOption(kyc.dof_type, collections.dofTypes)}}</vs-list-item>
                                <vs-list-item title="Propósito de negocio">{{kyc.business_purpose}}</vs-list-item>
                            </vs-list>
                        </div>
                    </div>
                  </vs-tab>
                  <vs-tab v-if="this.resultDataResponse.person_type == 1 || this.resultDataResponse.person_type == 0" label="Perfil Fiscal">
                    <vs-list>
                      <vs-list-item title="RFC">{{ this.resultDataResponse.tax_profile.rfc }}</vs-list-item>
                      <vs-list-item title="Nombre fiscal">{{ this.resultDataResponse.tax_profile.taxName }}</vs-list-item>
                      <vs-list-item title="Régimen fiscal">{{ this.resultDataResponse.tax_profile.taxRegime }}</vs-list-item>
                      <vs-list-item title="Código postal fiscal">{{ this.resultDataResponse.tax_profile.taxZipcode }}</vs-list-item>
                      <vs-list-item title="Uso de CFDI">{{ this.resultDataResponse.tax_profile.cfdi }}</vs-list-item>
                      <vs-list-item title="Validación">{{ explicitDateFormat(this.resultDataResponse.tax_profile.fiscalValidationTimestamp) }}</vs-list-item>
                    </vs-list>
                  </vs-tab>
                  <vs-tab label="Seguridad">
                      <vs-list>
                          <vs-list-item title="ID de Usuario">{{this.resultDataResponse.user_id}}</vs-list-item>
                          <vs-list-item title="Fecha de creación de usuario">{{this.resultDataResponse.user_created_at}}</vs-list-item>
                          <vs-list-item title="Fecha de último acceso">{{this.resultDataResponse.user_last_login}}</vs-list-item>
                          <vs-list-item title="Segundo Factor de Autenticación">{{this.resultDataResponse.user_2fa}}</vs-list-item>
                      </vs-list>
                  </vs-tab>
                  <vs-tab v-if="searchOptionSelected === 'CID'" label="Proyectos">
                    <vs-table
                      ref="projectsTable"
                      stripe
                      :data="resultDataResponse.projects_data"
                      noDataText="No hay datos disponibles"
                    >
                      <template slot="thead">
                        <vs-th>PID</vs-th>
                        <vs-th>Alias</vs-th>
                        <vs-th>Documentación</vs-th>
                      </template>
  
                      <template slot-scope="{ data }">
                        <vs-tr
                          :key="indextr"
                          v-for="(tr, indextr) in data"
                          :data="tr"
                        >
                          <vs-td class="bold"><a :href="$sanitizeUrl('/cobranza/' + tr.id)" target="blank">{{tr.id}}</a></vs-td>
                          <vs-td>{{ tr.alias }}</vs-td>
                          <vs-td>
                            <vs-button @click="downloadProjectDocuments(tr.id)" :disabled="tr.count_documents <= 0" size="small" color="primary">Descargar ({{ tr.count_documents }})</vs-button>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </vs-tab>
                </vs-tabs>
            </vx-card> -->
          </div>

          <!-- MODAL PARA SELECCIONAR FECHA PARA ESTADOS DE CUENTA DE USUARIO -->
          <vs-popup :active.sync="popUpStatementsActive" title="Estados de cuenta">
            <div class="vx-row">
              <div class="vx-col w-full">
                     <vs-input
                        label="Inicio (dd/mm/yyyy)"
                        class="w-full"
                        type="date"
                        v-model.lazy="startPeriodStatements"
                        name="startPeriodStatements"
                        v-validate="'required'"
                        autocomplete="off"
                     />
                </div>
                <div class="vx-col w-full mt-3 mb-3">
                     <vs-input
                        label="Fin (dd/mm/yyyy)"
                        class="w-full"
                        type="date"
                        v-model.lazy="endPeriodStatements"
                        name="endPeriodStatements"
                        v-validate="'required'"
                        autocomplete="off"
                     />
                </div>
                <div class="vx-col w-full">
                  <vs-button @click="downloadStatements()" :disabled="!startPeriodStatements || !endPeriodStatements" color="dark">Descargar</vs-button>
                </div>
            </div>
          </vs-popup>

          <!-- MODAL PARA SELECCIONAR FECHA PARA ESTADOS DE CUENTA DE PROYECTOS -->
          <vs-popup :active.sync="popUpProjectStatementsActive" title="Estados de cuenta">
            <div class="vx-row">
              <div class="vx-col w-full">
                     <vs-input
                        label="Inicio (dd/mm/yyyy)"
                        class="w-full"
                        type="date"
                        v-model.lazy="startPeriodStatements"
                        name="startPeriodStatements"
                        v-validate="'required'"
                        autocomplete="off"
                     />
                </div>
                <div class="vx-col w-full mt-3 mb-3">
                     <vs-input
                        label="Fin (dd/mm/yyyy)"
                        class="w-full"
                        type="date"
                        v-model.lazy="endPeriodStatements"
                        name="endPeriodStatements"
                        v-validate="'required'"
                        autocomplete="off"
                     />
                </div>
                <div class="vx-col w-full">
                  <vs-button @click="downloadProjectStatements()" :disabled="!startPeriodStatements || !endPeriodStatements" color="dark">Descargar</vs-button>
                </div>
            </div>
          </vs-popup>

          <!-- MODAL PARA SUBIR UN DOCUMENTO -->
          <vs-popup :active.sync="popUpUploadDocumentActive" title="Subir archivo">
            <div class="vx-row">
              <div class="vx-col w-full">
                <input type="file" id="evidence" name="evidence" ref="evidence" accept="image/png, image/jpeg, application/pdf">
                </div>
                <div class="vx-col w-full mt-5">
                  <vs-button @click="uploadUserDocument()" color="dark">Subir</vs-button>
                </div>
            </div>
          </vs-popup>

        </div>
      </template>
    </div>
  </div>
</template>

<script lang="js">
import formatHelper from '@mixins/formatHelper';
import dateHelper from '@mixins/dateHelper';
export default  {
  name: 'user-record-creator',
  mixins: [formatHelper, dateHelper],
  async mounted() {
    await this.getCollections();
  },
  data() {
    return {
      collections: {
        sofTypes: [],
        numberMonthlyTransactions: [],
        initialTrxProfileAverageDeposits: [],
        averageMonthlyEarningsMxnPm: [],
        averageMonthlyEarningsMxnPf: [],
        dofTypes: [],
        userRestrictions:[]
      },
      searchOptions: [
        'UID',
        'EMAIL',
        'RFC',
        'CURP',
        'IID',
        'CID',
        'SID',
        'PPID',
        'BPID'
      ],
      searchOptionSelected: "UID",
      lastSearchOptionSelected: null,
      inputSearch: null,
      resultDataResponse: null,
      popUpStatementsActive: false,
      popUpProjectStatementsActive:false,
      roleToDownloadStatements: null,
      projectToDownloadStatements:null,
      startPeriodStatements: null,
      endPeriodStatements: null,
      popUpUploadDocumentActive:false,
      userRestrictions: [],
      isUpdating:false,
      officialLetterNumber:null,
      restrictionSelected:null,
      actionToExecute:null
    }
  },
  computed: {
    avatarUrlIcon(){
      let iconUrl = "https://cdn.redgirasol.com/green/perfiles/hombre.jpg";
      if (this.resultDataResponse.personal_profile_data) {
        if (this.resultDataResponse.personal_profile_data.gender == "Mujer") {
          iconUrl = "https://cdn.redgirasol.com/green/perfiles/mujer.jpg";
        }
      } else {
        if (this.resultDataResponse.business_profile_data) {
          iconUrl = "https://cdn.redgirasol.com/green/LOGOS/redgirasol-siglas.png";
        }
      }
      return iconUrl;
    }, 
    userName(){
      let userName = "--";
      if (this.resultDataResponse.personal_profile_data) {
        userName = this.resultDataResponse.personal_profile_data.name;
      } else {
        if (this.resultDataResponse.business_profile_data) {
          userName = this.resultDataResponse.business_profile_data.name;
        }
      }
      return userName;
    },
    personalProfileData(){
      return this.resultDataResponse.personal_profile_data;
    },
    businessProfileData(){
      return this.resultDataResponse.business_profile_data;
    },
    showUserPldCard(){
      return (this.rolesOfUser.includes("pld") || this.rolesOfUser.includes("admin"));
    },
    btnUpdatePldUserListEnabled(){
      return this.rolesOfUser.includes("admin");
    },
  },
  methods: {
    async searchUserData(searchParam, searchInput){
      this.showLoading(true);
      this.resultDataResponse = null;
      this.userRestrictions = [];
      await axios.post('/api/clients-control/user-record-creator/create', {
          search_param: searchParam,
          search_input: searchInput,
      }).then(response => {
        this.lastSearchOptionSelected = searchParam;
        this.resultDataResponse = response.data;
        // EN ESTE CASO SE SETEAN LOS DATOS MEDIANTE ID YA QUE AUNQUE PAREZCA EL MISMO OBJETO QUE LLEGA DESDE EL API, NO LO ES
        if (response.data.user_restrictions) {
          this.resultDataResponse.user_restrictions.forEach(opt => {
            if (opt.name == "LPB") {
              this.officialLetterNumber = opt.official_letter_number;
            }
						this.userRestrictions.push(opt.id);
          })
        }
        this.showLoading(false);
      }).catch(error => {
        if(error.response){
          this.errorNotifDialog("Aviso", error.response.data.message);
        }
        else {
          this.errorNotifDialog("Error", "Ha ocurrido un error en la creación");
        }
        this.showLoading(false);
      });
    },
    async downloadUserDocuments(){
      try {
        let url = `${this.ApiDomain}/api/adminDownloadUserDocuments/${this.resultDataResponse.user_id}?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      } catch (e) {
        this.warn(e)
        this.showError(e);
      }
    },
    async downloadProjectDocuments(projectId){
      try {
        let url = `${this.ApiDomain}/api/adminDownloadProjectDocuments/${projectId}?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      } catch (e) {
        this.warn(e)
        this.showError(e);
      }
    },
    getOption(value, collection){
      let result = "--";
      let match = collection.find(item => item.id === value);
      if (match) {
        result = match.name;
      }
      return result;
    },
    async getCollections(){
      try {
        let collectionsObjects = ['sofTypes', 'monthlyTransactionAverage', 'averageDeposits', 'getFundsDestinations', 'getUserRestrictions', 'averageMonthlyEarningsMxnPm', 'averageMonthlyEarningsMxnPf'];
        let params = "with[]=" + collectionsObjects.join("&with[]=");
        let res = await this.publicApiGet(`/api/v1/forms/getPublicFormCollections?${params}`);
        let colls = res.data;
        this.collections.sofTypes = colls.sofTypes;
        this.collections.numberMonthlyTransactions = colls.monthlyTransactionAverage;
        this.collections.initialTrxProfileAverageDeposits = colls.averageDeposits;
        this.collections.averageMonthlyEarningsMxnPm = colls.averageMonthlyEarningsMxnPm;
        this.collections.averageMonthlyEarningsMxnPf = colls.averageMonthlyEarningsMxnPf;
        this.collections.dofTypes = colls.getFundsDestinations;
        this.collections.userRestrictions = colls.getUserRestrictions;
      }
      catch (e) {
      }
    },
    selectPeriodStatements(role){
      this.roleToDownloadStatements = role;
      this.popUpStatementsActive = true;
    },
    selectProjectStatements(pid){
      this.projectToDownloadStatements = pid;
      this.popUpProjectStatementsActive = true;
    },
    async downloadStatements(){
      try {
        let role = this.roleToDownloadStatements.role_name_db;
        let idToSearch = this.roleToDownloadStatements.role_id;
        if (role == "investor") {
          idToSearch = this.resultDataResponse.user_id;
        }
        let url = `${this.ApiDomain}/api/adminDownloadUserStatements/${role}/${idToSearch}/${this.startPeriodStatements}/${this.endPeriodStatements}?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      } catch (e) {
        this.warn(e)
        this.showError(e);
      }
    },
    async downloadProjectStatements(){
      try {
        let idToSearch = this.projectToDownloadStatements;
        let url = `${this.ApiDomain}/api/adminDownloadProjectStatements/${idToSearch}/${this.startPeriodStatements}/${this.endPeriodStatements}?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      } catch (e) {
        this.warn(e)
        this.showError(e);
      }
    },
    async downloadContract(contract){
      try {
        let url = `${this.ApiDomain}/api/adminDownloadUserContract/${contract.contract_id}/${this.resultDataResponse.user_id}?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      } catch (e) {
        this.warn(e)
        this.showError(e);
      }
    },
    async uploadUserDocument(){
      let evidence = document.getElementById('evidence');
      if(evidence.files.length == 0){
          this.warningNotif("Aviso", 'Agrega un archivo para subir', 4000);
          return 0;
      }
      this.showLoading(true);
      var data = new FormData();
      data.append("user_id", this.resultDataResponse.user_id);
      data.append("evidence", evidence.files[0]);
      await axios.post('/api/clients-control/user-record-creator/upload-document', data).then(response => {
          this.successNotif('Aviso', response.data.message);
          document.getElementById("evidence").value = "";
          this.popUpUploadDocumentActive = false;
      }).catch(error => {
          if(error.response.data.message != undefined){
              this.errorNotif("Aviso", error.response.data.message, 4000);
          }else{
              this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
          }
      });
      this.showLoading(false);
    },
    async switchPldOption(option) {
      if (this.isUpdating) {
        return;
      }
      this.isUpdating = true;
      let restrictionAlreadySelected = this.resultDataResponse.user_restrictions? this.resultDataResponse.user_restrictions.find((obj) => obj.id === option.id):null;
      this.actionToExecute = restrictionAlreadySelected? 'delete':'add';
      if (option.name == "LPB" && this.actionToExecute == "add") {
        if (!this.officialLetterNumber) {
          await new Promise(resolve => setTimeout(resolve, 200));
          this.userRestrictions.pop();   
          this.isUpdating = false;
          this.showLoading(false);
          this.errorNotif("Aviso", 'Debes ingresar el número de oficio', 4000);
          return;       
        } else {
          option.official_letter_number = this.officialLetterNumber;
        }
      }
      this.restrictionSelected = option;
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Realizar Modificación`,
        text: `¿Estás seguro que deseas modificar el usuario en ${option.name}?`,
        acceptText: "Aceptar",
        cancelText: 'Cancelar',
        accept: this.executeSwitchPldOption,
        cancel: () => {
          if (this.actionToExecute == "add") {
            this.userRestrictions.pop();   
          } else {
            this.userRestrictions.push(this.resultDataResponse.user_restrictions.find((obj) => obj.id === option.id).id);
          }
          this.restrictionSelected = null;
          this.isUpdating = false;
          this.actionToExecute = null;
        }
      });
    },
    async executeSwitchPldOption() {
      let option = this.restrictionSelected;
      let action = this.actionToExecute;
      this.showLoading(true);
      await axios.post('/api/clients-control/user-record-creator/switch-pld-option', {
        user_id: this.resultDataResponse.user_id,
        restriction: option,
        action: action
      }).then(response => {
        this.successNotif('Aviso', response.data.message);
        this.showLoading(false);
        if (!this.resultDataResponse.user_restrictions) {
          this.resultDataResponse.user_restrictions = [];
        }
        if (action == "add") {
          this.resultDataResponse.user_restrictions.push(option);
        } else {
          this.resultDataResponse.user_restrictions = this.resultDataResponse.user_restrictions.filter(obj => obj.id !== option.id);
          if (option.name == "LPB") {
            this.officialLetterNumber = null;
          }
        }
        // this.isUpdating = false;
      }).catch(error => {
        if (this.actionToExecute == "add") {
          this.userRestrictions.pop();   
        } else {
          this.userRestrictions.push(this.resultDataResponse.user_restrictions.find((obj) => obj.id === option.id).id);
        }
        this.showLoading(false);
        // this.isUpdating = false;
        if(error.response.data.message != undefined){
          this.errorNotif("Aviso", error.response.data.message, 4000);
        }else{
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      })
      this.isUpdating = false;
      this.restrictionSelected = null;
      this.actionToExecute = null;
    },
    async sendQuestionnaire() {
      if (this.isUpdating) {
        return;
      }
      this.isUpdating = true;
      this.showLoading(true);
      let action = 'send_quiestionnaire';
      await axios.post('/api/clients-control/user-record-creator/switch-pld-option', {
        user_id: this.resultDataResponse.user_id,
        restriction: null,
        action: action
      }).then(response => {
        this.successNotif('Aviso', response.data.message);
        this.showLoading(false);
        this.isUpdating = false;
      }).catch(error => {
        this.showLoading(false);
        this.isUpdating = false;
        if(error.response.data.message != undefined){
          this.errorNotif("Aviso", error.response.data.message, 4000);
        }else{
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      })
    },
    showError(e){
      let err = "Ha ocurrido un error, intenta más tarde.";
      if(e.response && e.response.data && e.response.data.message){
        err = e.response.data.message;
      }
      this.errorNotifDialog('Error en la petición', err);
    }
  }
}
</script>

<style>
    .con-vs-dialog {
        z-index: 9999999 !important;
    }
</style>